import { render, staticRenderFns } from "./order.vue?vue&type=template&id=40ba7321&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.css?vue&type=style&index=0&id=40ba7321&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba7321",
  null
  
)

export default component.exports